import { render, staticRenderFns } from "./CreateRegis.vue?vue&type=template&id=b46573fe&"
import script from "./CreateRegis.vue?vue&type=script&lang=js&"
export * from "./CreateRegis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports